import { CsvSyncButton } from 'components/CsvButtons';

const data = [
  ['Company Name', 'Company Country', 'Company Tradestyle names', 'Company Address', 'Company NationalID or Reg Number'],
  ['TradeSun Inc', 'United States of America', 'TradeSun', '2196 Carmel Valley Rd Ste D, Del Mar, United States, 92014-3766', ''],
  ['TradeSun Limited', 'UK', 'TradeSun', 'Towngate House, POOLE, United Kingdom, BH15 2PW', '12851382'],
];

export default function SampleCsvLink() {
  return (
    <CsvSyncButton
      text="Download Sample CSV"
      data={data}
    />
  );
}
